const PAGE_KINDS = new Set(['facebook_page', 'instagram_business']);

export function metaBusinessLabel(row) {
  const name = row?.meta?.businessName || row?.meta?.businessId;
  if (name) return `Business: ${name}`;
  if (PAGE_KINDS.has(row?.providerAccountKind)) return 'Personal Pages';
  return 'Other';
}

export function groupMetaConnections(rows) {
  const groups = [];
  const index = new Map();
  (rows || []).forEach((row) => {
    const label = metaBusinessLabel(row);
    if (!index.has(label)) {
      const group = { label, rows: [] };
      index.set(label, group);
      groups.push(group);
    }
    index.get(label).rows.push(row);
  });
  groups.sort((a, b) => {
    if (a.label === 'Personal Pages') return 1;
    if (b.label === 'Personal Pages') return -1;
    if (a.label === 'Other') return 1;
    if (b.label === 'Other') return -1;
    return a.label.localeCompare(b.label);
  });
  return groups;
}
